/**
 * Light or dark for the control panel: the staff member's choice, kept in this browser, or the
 * system's setting until they choose. Dark mode is the `.dark` class on <html>.
 */
export type Theme = 'light' | 'dark'

const KEY = 'arvaseo-cp-theme'

export function storedTheme(): Theme | null {
  try {
    const value = window.localStorage.getItem(KEY)
    return value === 'light' || value === 'dark' ? value : null
  } catch {
    return null
  }
}

export function currentTheme(): Theme {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light'
}

export function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark')
}

/** At start-up: the stored choice, else the system's. */
export function initTheme() {
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  applyTheme(storedTheme() ?? (systemDark ? 'dark' : 'light'))
}

export function setTheme(theme: Theme) {
  applyTheme(theme)
  try {
    window.localStorage.setItem(KEY, theme)
  } catch {
    // Private windows can refuse storage; the choice still holds until the page reloads.
  }
}
